import { DATE_FORMAT } from "constants"
import dayjs from "dayjs"

const CallTransformer = response => {
  return response?.map(item => ({
    value: item?.id,
    label: `${dayjs(item?.callTime).format(DATE_FORMAT)} | ${dayjs(item?.callTime).format("hh:mm A")} | ${
      item?.duration
    }`,
    ...item,
  }))
}

export default CallTransformer
